import { Avatar, Container, Grid, Link, styled, Typography } from "@mui/material";
import { TableTabs } from "components/Table/components";
import { PageHeader } from "components/Reports/components";
import { forwardRef, memo, SyntheticEvent, useRef, useState } from "react";
import shortid from "shortid";
import Rating from "@mui/material/Rating";
import StarEmptyIcon from "assets/icons/StarEmptyIcon";
import StarFilledIcon from "assets/icons/StarFilledIcon";
import reportItems from "assets/js/reportItems";
import { useDispatch, useSelector } from "react-redux";
import { appSetFavoriteReports } from "store/actions/appAction";
import { useNavigate } from "react-router-dom";
import useScroll from "helpers/useScroll";

const tab = {
  title: "گزارش ها",
  description: "لیست گزارشات حسابداری",
};

const ReportCardContainer = styled(Link)(
  ({ theme, clickable }: { theme?: ThemeObjType; clickable?: boolean }) => ({
    display: "grid",
    position: "relative",
    cursor: clickable ? "pointer" : "initial",
    gridTemplateColumns: "16% 40% 20%",
    gridGap: "10px",
    justifyContent: "space-between",
    backgroundColor: "white",
    borderRadius: theme?.shape.borderRadius,
    height: "104px",
    padding: "8px 16px 8px 24px",
    color: "#1A1919 !important",
  })
);

const ReportCardItem = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
}));
const MiddleItem = styled(ReportCardItem)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "space-evenly",
  alignItems: "baseline",
}));
const LastItem = styled(ReportCardItem)(({ theme }) => ({
  justifyContent: "end",
}));
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: "#E8F1FF",
  padding: "10px",
  width: "70px",
  height: "70px",
}));
const DisableWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  backgroundColor: "#6565653a",
  width: "100%",
  height: "100%",
  borderRadius: theme.shape.borderRadius,
}));

const ReportSection = memo(
  forwardRef(({ item }: { item: (typeof reportItems)[0] }, ref) => {
    const dispatch = useDispatch();
    // @ts-ignore
    const  favoriteReports  = useSelector((state) => state.appReducer?.favoriteReports) as typeof reportItems[0]
    
    const navigate = useNavigate();
    return (
      // @ts-ignore
      <div ref={ref}>
        <Typography
          variant="body1"
          color={item.title === "نشان شده ها" ? "primary" : "black"}
          fontWeight="bold"
          sx={{ padding: "20px 0 10px 0", marginBottom: "22px" }}
        >
          {item.title}
        </Typography>
        <Grid sx={{ paddingInlineEnd: "20px" }} container spacing={4}>
          {item.subItems.map((it, index) => (
            <Grid key={index} item xl={6} lg={6} md={6} sm={10} xs={12}>
              <ReportCardContainer
                href={it.url}
                clickable={it?.url ? true : false}
                // @ts-ignore
                onClick={(e) => {
                  const url = it?.url;
                  e.preventDefault();
                  return url ? navigate(url) : null;
                }}
              >
                <ReportCardItem>
                  <StyledAvatar src={it.avatar} />
                </ReportCardItem>
                <MiddleItem>
                  <Typography>{it.title}</Typography>
                  {/*<Typography fontSize={12} color={theme.palette.text.disabled}>{it.description}</Typography>*/}
                </MiddleItem>
                <LastItem>
                  <Rating
                    onChange={(e: SyntheticEvent) => {
                      e.preventDefault();
                      dispatch(appSetFavoriteReports(it, favoriteReports.subItems));
                    }}
                    onClick={(event) => event.stopPropagation()}
                    name="customized-color"
                    value={favoriteReports.subItems.filter((object) => object.title === it.title).length}
                    emptyIcon={<StarEmptyIcon />}
                    icon={<StarFilledIcon />}
                    max={1}
                  />
                </LastItem>
                {!it?.url && <DisableWrapper />}
              </ReportCardContainer>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  })
);

const ReportSectionContainer = styled("div")({
  paddingBottom: "50px",
});

const ReportPageComponent = () => {
  const [activeTab, setActiveTab] = useState(reportItems[0]);
  const itemsRef = useRef([] as HTMLDivElement[]);
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollTo } = useScroll();
     // @ts-ignore
  const  favoriteReports  = useSelector((state) => state.appReducer?.favoriteReports) as typeof reportItems[0]

  const shownTabs = favoriteReports.subItems.length > 0 ? [favoriteReports, ...reportItems] : reportItems;

  const handleChangeTab = (tab: (typeof reportItems)[0]) => {
    const index = shownTabs.findIndex((object) => object.key === tab.key);
    setActiveTab(tab);
    scrollTo(itemsRef.current[index], -100);
  };

  return (
    <Container maxWidth="lg">
      <div className="warp-table">
        <div className="header-table">
          <PageHeader tab={tab} />
        </div>
        <div className="sticky z-[2] bg-[#f5f6fa] top-16 overflow-x-auto" >
          <TableTabs
            tabs={shownTabs}
            activeTabKey={shownTabs.findIndex((item) => item === activeTab)}
            activeTab={activeTab}
            setActiveTab={handleChangeTab}
          />
        </div>
        <ReportSectionContainer ref={containerRef}>
          {shownTabs.map((it, key) => {
            return (
              <ReportSection
                ref={(el: any) => (itemsRef.current[key] = el)}
                key={shortid.generate()}
                item={it}
              />
            );
          })}
        </ReportSectionContainer>
      </div>
    </Container>
  );
};

export default ReportPageComponent;
